import { Action } from "redux";
import { IWorkflowItem, IWorkflowItemStep } from "../../../common/sharedTypes";

export interface IDataEntryQueueState {
  workflowItemSteps: IWorkflowItemStep[];
  openWorkflowItemStep: IWorkflowItemStep;
}

// ACTIONS
export interface IDataEntryQueueAction extends Action {
  type: "@@dataentryqueue/GET_DATA_ENTRY_QUEUE_REPORTS";
  payload: {};
}

export enum DataEntryQueueActionTypes {
  SEARCH_REPORTS = "@@dataentryqueue/GET_DATA_ENTRY_QUEUE_REPORTS",
  OPEN_DATA_ENTRY_REPORT = "@@dataentryqueue/OPEN_DATA_ENTRY_REPORT",
  ASSIGN_AND_OPEN_REPORT = "@@dataentryqueue/ASSIGN_AND_OPEN_DATA_ENTRY_REPORT",
  UNASSIGN = "@@dataentryqueue/UNASSIGN",
  COMPLETE_DATA_ENTRY = "@@dataentryqueue/COMPLETE_DATA_ENTRY",
  LOAD_DATA_ENTRY_IMAGE = "@@dataentryqueue/LOAD_DATA_ENTRY_IMAGE",
  REMOVE_FROM_QUEUE = "@@dataentryqueue/REMOVE_FROM_QUEUE",
  LOADING_WORKFLOW_STEPS = "@@dataentryqueue/LOADING_WORKFLOW_STEPS",
  TOTAL_WORKFLOW_STEPS = "@@dataentryqueue/TOTAL_WORKFLOW_STEPS",
}

export class PrintRequest {
  content: string;
  helpers: string;
  data: any;
}

export type QNotificationActions = IDataEntryQueueAction;
